const SENTINEL = {};
export function memoize(target, name, descriptor) {
    if (typeof descriptor.value === 'function') {
        return memoizeMethod(target, name, descriptor);
    }
    if (typeof descriptor.get === 'function') {
        return memoizeGetter(target, name, descriptor);
    }
    {
        throw new Error('@memoize');
    }
}
function memoizeGetter(target, name, descriptor) {
    const memoizedName = `_memoized_${name}`;
    const get = descriptor.get;
    return {
        ...descriptor,
        get() {
            if (!this.hasOwnProperty(memoizedName)) {
                const callResult = get.call(this);
                // do not memoize undefined, modified by mhicke, 23.09.2017
                if (typeof callResult !== 'undefined') {
                    this[memoizedName] = callResult;
                }
                return callResult;
            }
            return this[memoizedName];
        }
    };
}
function memoizeMethod(target, name, descriptor) {
    if (descriptor.value.length > 0) {
        throw new Error('@memoizeMethod');
    }
    const memoizedName = `_memoized_${name}`;
    const value = descriptor.value;
    target[memoizedName] = SENTINEL;
    return {
        ...descriptor,
        value() {
            if (this[memoizedName] === SENTINEL) {
                const callResult = value.call(this);
                if (typeof callResult !== 'undefined') {
                    this[memoizedName] = callResult;
                }
                else {
                    return callResult;
                }
            }
            return this[memoizedName];
        }
    };
}
